var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.count ? _c('div', {
    staticClass: "add-to-cart add-to-cart_large"
  }, [_c('span', {
    staticClass: "add-to-cart__increase",
    attrs: {
      "data-e2e": "add-to-cart"
    },
    on: {
      "click": function ($event) {
        return _vm.emit('send');
      }
    }
  }, [_vm._v("\n    +1 шт.\n  ")]), _vm._v(" "), _c('nuxt-link', {
    staticClass: "add-to-cart__current",
    attrs: {
      "to": "/cart/"
    }
  }, [_vm._v("\n    В корзине " + _vm._s(_vm.count) + " шт\n    "), _c('span', {
    staticClass: "add-to-cart__subtitle"
  }, [_vm._v(" Перейти в корзину ")])])], 1) : _vm.loading ? _c('Button', {
    class: {
      'add-to-cart__btn_preorder': _vm.type === 'preorder'
    },
    attrs: {
      "size": "49",
      "fluid": "",
      "theme": "red",
      "loading": ""
    }
  }) : _c('Button', {
    staticClass: "add-to-cart__btn",
    class: {
      'add-to-cart__btn_preorder': _vm.type === 'preorder'
    },
    attrs: {
      "size": "49",
      "fluid": "",
      "icon": "cart",
      "data-e2e": "add-to-cart"
    },
    on: {
      "click": function ($event) {
        return _vm.emit('send');
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.type === 'default' ? 'Добавить в корзину' : 'Оформить предзаказ') + "\n")]);
}
var staticRenderFns = []

export { render, staticRenderFns }